import React, { useEffect, useState } from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  Platform,
} from "react-native";

import ElementsList from "../list/ElementsList";
import { isBaseCoreElement } from "../../../../helpers/utils";
import Dialog from "../../common/dialog";
import ManaButton from "../../common/ManaButton";
import ManaTextInput from "../../common/ManaTextInput";
import AppMessages from "../../../../config/AppMessages";
//import AddIcon from "../../common/icons/elements/AddIcon";
import ElementSmileyIcon from "../../common/icons/elements/ElementSmileyIcon";
import AppTheme from "../../AppTheme";

export default function BaseCoreElementsPicker({
  controller,
  isOpen,
  onClose = () => {},
  createCoreElement = () => {},
  onCoreElementSelected = () => {},
}) {
  if (!controller.state) return null;

  const [isEditMode, setIsEditMode] = useState(false);
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState(
    AppMessages.CreateCoreElementMessage,
  );
  const baseElements = (controller.state.elements || []).filter((el) =>
    isBaseCoreElement(el.name),
  );

  // Create core element on the fly
  const createElement = () => {
    if (!name) return;
    createCoreElement(name);
  };

  useEffect(() => {
    if (isEditMode) {
      setTitle("Great!");
      setDescription(
        "Your new “Core Element” will be visible on your Reflection page.",
      );
    } else {
      setTitle("Are you sure?");
      setDescription(AppMessages.CreateCoreElementMessage);
    }
  }, [isEditMode]);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  return (
    <>
      {isOpen ? (
        <Dialog.Container onClose={onClose} showCloseButton>
          <Dialog.Title>
            <Text style={styles.title}>{title}</Text>
          </Dialog.Title>
          <Dialog.Description style={styles.confirmText}>
            {description}
          </Dialog.Description>
          {!isEditMode ? (
            <Text style={styles.subTitle}>Try one of these:</Text>
          ) : null}

          {isEditMode ? (
            <View style={styles.inputContainer}>
              <View style={[styles.imageContainer]}>
                <ElementSmileyIcon style={styles.icon} />
              </View>

              <ManaTextInput
                debounceDelay={500}
                style={styles.input}
                placeholderTextColor="#9C9EB9"
                name={"activityEdit"}
                placeholder="Enter Element Name"
                onTextChanged={(text) => setName(text)}
                value={""}
              />
              <View style={styles.buttons}>
                <ManaButton
                  onPress={toggleEditMode}
                  style={styles.button}
                  text="Back"
                />

                <ManaButton
                  isMainButton
                  disabled={!name}
                  onPress={createElement}
                  style={styles.button}
                  text="Create"
                />
              </View>
            </View>
          ) : (
            <>
              <ScrollView
                style={{
                  paddingTop: 10,
                  maxHeight: 400,
                }}
              >
                <ElementsList
                  title=""
                  elements={baseElements}
                  controller={controller}
                  onElementSelected={(element) =>
                    onCoreElementSelected(element.id)
                  }
                  noIcons
                />
              </ScrollView>
              {/*  <TouchableOpacity
                style={styles.newButton}
                onPress={toggleEditMode}
              >
                <AddIcon style={styles.icon} />
                <Text style={styles.newButtonText}>Create New</Text>
              </TouchableOpacity> */}
              <Text onPress={() => onCoreElementSelected()} style={styles.link}>
                Continue without Parent
              </Text>
            </>
          )}
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  confirmText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 13,
    lineHeight: 16,
    letterSpacing: -0.078,
    color: "#2D3142",
  },
  subTitle: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 4,
    marginBottom: 8,
  },
  link: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.5,
    color: AppTheme.DEFAULT_COLOR,
    textAlign: "center",
    width: "100%",
    marginVertical: 20,
  },
  newButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minHeight: 44,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
    backgroundColor: "#F4F6FA",
    borderRadius: 100,
  },
  newButtonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  button: {
    maxWidth: 144,
    height: 40,
    marginBottom: 0,
  },
  inputContainer: {
    position: "relative",
  },
  input: {
    height: 50,
    marginBottom: 10,
    paddingLeft: 50,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  imageContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "#FFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  icon: {
    width: 30,
    height: 30,
    marginHorizontal: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
